import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import RingLoader from "react-spinners/RingLoader";
import { toast } from "react-toastify";

import "../Join.scss";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [isSuccessfull, setIsSuccessfull] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await axios.post(
          `${process.env.REACT_APP_EDAIN_URL}/api/auth/signup/confirm/${location.pathname.replace(
            "/verifyemail/",
            ""
          )}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`
            }
          }
        );

        if (response.status === 201 || response.status === 200) {
          setIsSuccessfull(true);
          const successActions = () => {
            localStorage.setItem("jwt", response.data.token);
            navigate("/");
          };
          setTimeout(successActions, 2000);
        }
      } catch (e) {
        setIsSuccessfull(false);
        if (e.response) {
          switch (e.response.status) {
            case 400:
              setError("Invalid invite link");
              return;
            case 403:
              setError("Invalid email confirmation link");
              return;
            case 404:
              setError("Invalid invite link");
              return;
            case 422:
              setError("Invalid invite link");
              return;
            case 409:
              setError("Email already confirmed");
              setTimeout(() => navigate("/login"), 2000);
              return;
            default:
              setError("Ooops.. something happened. Please try again");
              toast.error("Oops.. There was an error!", { toastId: "verifyEmail-error" });
              return;
          }
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  let toRender;

  if (loading) {
    toRender = <RingLoader color={"#023aff"} size={150} />;
  } else if (isSuccessfull) {
    toRender = (
      <>
        <h3 className="font-size-32 font-pnb text-light text-center title mb-0 text-center mb-4">
          Your email has been confirmed
        </h3>

        <h3 className="font-size-32 font-pnb text-light text-center d-block">
          Welcome to The <br />
          Knowledge Revolution
        </h3>

        <button
          className="zixxar-blue-button font-size-20 font-pnm radius-12 mt-5"
          onClick={() => navigate("/")}>
          <span>Return to website</span>
        </button>
      </>
    );
  } else {
    toRender = (
      <>
        <h3 className="font-size-24 text-light font-pnb text-center d-block">{error}</h3>

        <button
          className="zixxar-blue-button btn-height-56 font-size-20 font-pnm radius-12 control-2fa-btn mt-5"
          onClick={() => navigate("/login")}>
          <span>Return to login</span>
        </button>
      </>
    );
  }

  return (
    <div className="status d-flex align-items-center justify-content-center flex-column">
      {toRender}
    </div>
  );
};
export default VerifyEmail;
